var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.869,
    height: 35,
    viewBox: "0 0 39.869 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle",
    transform: "translate(-0.552 -0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_100",
    d: "M20.487.9a5.224,5.224,0,0,1,4.472,2.523h0L39.721,28.064A5.224,5.224,0,0,1,35.236,35.9H5.719a5.224,5.224,0,0,1-4.453-7.86h0L16.02,3.409A5.224,5.224,0,0,1,20.487.9Zm0,3.483A1.741,1.741,0,0,0,19,5.213h0L4.268,29.806a1.741,1.741,0,0,0,1.47,2.612H35.216a1.741,1.741,0,0,0,1.5-2.588h0L21.975,5.217A1.741,1.741,0,0,0,20.487,4.383Zm.017,21.07a1.741,1.741,0,0,1,.2,3.47l-.221.012a1.741,1.741,0,0,1-.2-3.47Zm-.017-13.931a1.741,1.741,0,0,1,1.729,1.537l.012.2v6.965a1.741,1.741,0,0,1-3.47.2l-.012-.2V13.263A1.741,1.741,0,0,1,20.487,11.522Z",
    transform: "translate(0 0)",
    fill: "#ff6666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.24eaefb609205afd7d91f6a2a5777ab0.svg";
export { ForwardRef as ReactComponent };